import React, { useCallback, useRef, useState } from 'react'
import { Alert } from '../../components'
import { useResizeObserver } from '../../hooks'

const PageLayout = ({ alerts = {}, children, className }) => {
    const alertsWrapperRef = useRef(null);
    const [alertsHeight, setAlertsHeight] = useState(0)

    const handleAlertsResize = useCallback((alertsDomReact) => {
        setAlertsHeight(alertsDomReact.height)
    }, []);
    
    useResizeObserver(alertsWrapperRef.current, handleAlertsResize);

    return (
        <div className={`page-layout ${className || ''}`} style={{ '--alerts-height': `${alertsHeight}px` }}>
            <div ref={alertsWrapperRef} className='page-alerts container'>
                {
                    Object.keys(alerts).map((id) => <Alert key={id} {...alerts[id]} />)
                }
            </div>
            <div className='page-container'>
                {children}
            </div>
        </div>
    )
}

export default PageLayout